module.exports = __webpack_public_path__ + "img/intellectual.06da6217.png";